export const PixelFbNoscript = () => (
  <noscript
    dangerouslySetInnerHTML={{
      __html: `<img height="1" width="1" alt="" style="display:none" src="https://www.facebook.com/tr?id=444706736107292&ev=PageView&noscript=1" />`,
    }}
  />
);
